import { EventEmitter, OnInit, Component, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDossierComponent } from '@kv-common-components/kv-common-components';
import { EspaceDocumentaireService } from '@kv-common-components/kx-services';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-document-component',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss'],
})
export class DocumentComponent
    extends CommonDossierComponent
    implements OnInit
{
    @Input() document: any;
    @Input() checked = false;
    @Input() withAppointment = false;
    @Input() webCallBackMedical: boolean;
    @Input() folder: any;
    @Input() listePieces;
    @Output() documentNotInUserPossession: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    examDetails: any;
    documentStatus: string;
    showExamDetails = false;

    constructor(
        logger: NGXLogger,
        espaceDocService: EspaceDocumentaireService,
        private router: Router,
        private i18nPipe: I18nPipe
    ) {
        super(logger, espaceDocService);
    }

    ngOnInit(): void {
        this.setExamDetails();
        this.setDocumentStatus();
    }

    setExamDetails(): void {
        if (this.document) {
            if (this.document.typologie === 'BILAN SANGUIN COMPLET') {
                this.examDetails = {
                    title: 'documentselection.bloodtest.header.title',
                    subtitle: 'documentselection.bloodtest.header.subtitle',
                    leftList: [
                        'documentselection.bloodtest.body.list.bloodcount',
                        'documentselection.bloodtest.body.list.gt',
                        'documentselection.bloodtest.body.list.bloodformula',
                        'documentselection.bloodtest.body.list.vih',
                        'documentselection.bloodtest.body.list.ldl',
                        'documentselection.bloodtest.body.list.sedimentationrate',
                        'documentselection.bloodtest.body.list.asat',
                    ],
                    rightList: [
                        'documentselection.bloodtest.body.list.glucose',
                        'documentselection.bloodtest.body.list.vhc',
                        'documentselection.bloodtest.body.list.creatinine',
                        'documentselection.bloodtest.body.list.platelets',
                        'documentselection.bloodtest.body.list.triglycerides',
                    ],
                };
            } else if (this.document.typologie === 'BILAN BIOLOGIQUE') {
                this.examDetails = {
                    title: 'documentselection.biologyreport.header.title',
                    subtitle: 'documentselection.biologyreport.header.subtitle',
                    leftList: [
                        'documentselection.biologyreport.body.list.globularnum',
                        'documentselection.biologyreport.body.list.gt',
                        'documentselection.biologyreport.body.list.creatinine',
                        'documentselection.biologyreport.body.list.platelets',
                        'documentselection.biologyreport.body.list.sedimentation',
                    ],
                    rightList: [
                        'documentselection.biologyreport.body.list.glucose',
                        'documentselection.biologyreport.body.list.bloodformula',
                        'documentselection.biologyreport.body.list.asat',
                        'documentselection.biologyreport.body.list.ldl',
                        'documentselection.biologyreport.body.list.triglycerides',
                    ],
                };
            }
        }
    }

    setDocumentStatus(): void {
        if (this.document) {
            this.documentStatus = `documentselection.files.status.${this.document.statut}`;
            // specific to the case when the document statut in espace client is not up to date
            if (
                this.document.statut === this.documentStatusList.enAttente &&
                this.document.transmis
            ) {
                this.documentStatus = 'documentselection.files.status.RECU';
            }
            if (this.document.statut === this.documentStatusList.nonConforme) {
                this.listePieces.forEach((piece) => {
                    if (piece.codeAIA === this.document.codeAIA) {
                        const documentStatusNonConformeLibelle =
                            this.i18nPipe.transform(
                                'documentselection.files.status.NON_CONFORME'
                            );
                        this.documentStatus =
                            documentStatusNonConformeLibelle +
                            ' ' +
                            piece.motivNonValide;
                    }
                });
            }
        }
    }

    transmitDocument(): void {
        localStorage.setItem('selectedDocumentType', this.document.typologie);
        if (this.folder) {
            this.router.navigateByUrl(
                '/souscription/document-medicale/document-selection-type',
                {
                    state: {
                        data: {
                            folder: this.folder,
                        },
                    },
                }
            );
        } else {
            this.logger.debug('Could not get jouve folder');
        }
    }

    toggleExamDetails(): void {
        this.showExamDetails = !this.showExamDetails;
    }

    onCheckboxChange(): void {
        if (this.document.idApi) {
            this.documentNotInUserPossession.emit(this.checked);
        }
    }
    disabletransmitDocButton(document): boolean {
        return (
            this.filesConforme(document) ||
            ((this.filesProvided(document) || document.transmis) &&
                document.statut !== 'NON_CONFORME')
        );
    }
}
